import script from "./BestPlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./BestPlan.vue?vue&type=script&setup=true&lang=ts"

import "./BestPlan.vue?vue&type=style&index=0&id=51663080&lang=scss"

const __exports__ = script;

export default __exports__